import React from "react";
import axios from "axios";
import { setUserSessionAuthKey } from "../../Component/commonUtils";

let recipient = "",
  userGUID = "",
  userDetailsResponse = "";
let userDetailResArray = [];
let userSessionAuthKeyReturnValue = setUserSessionAuthKey();
export const SignUpVerifyEmail = (emailId, Password) => {
  let userEmailPasswordDetails = {
    emailID: emailId,
    password: Password
  };

  let splittedUrl = window.location.href.split("/");

  const encodedEmail = encodeURIComponent(emailId);

  axios.get("/user/getByEmail?emailId=" + encodedEmail).then((response) => {
    userDetailsResponse = response.data;
    userDetailsResponse.emailVerificationStatus = false;
    recipient = response.data.emailID;
    userGUID = response.data.userGUID;

    // let temp = localStorage.getItem("RBLAllUserDetails") || [];
    // if (temp.length > 0) {
    //   temp = JSON.parse(temp);
    // }
    // temp.push(userDetailsResponse);

    // localStorage.setItem("RBLAllUserDetails", JSON.stringify(temp));
    let userSelectedLanguage = localStorage.getItem("selectedLanguage");

    let userTimeZone = localStorage.getItem("userTimeZone");

    let sendMailObject = {
      emailType: "emailVerification",
      recipient: recipient,
      status: "New",
      noOfAttempts: 0,
      userGUID: userGUID,
      userName: response.data.userName,
      firstName: response.data.firstName,
      lastName: response.data.lastName,
      htmlCode:
        splittedUrl[splittedUrl.length - 1].includes("#") ||
        splittedUrl[splittedUrl.length - 1].toUpperCase() == "ANNUALREPORT"
          ? ""
          : splittedUrl[splittedUrl.length - 1], //current page name
      reportGuid:
        splittedUrl[splittedUrl.length - 2].toUpperCase() == "ANNUALREPORT"
          ? ""
          : splittedUrl[splittedUrl.length - 2]
    };

    const url = "/emailQueueController/insertEmailQueueAndSendMail";
    const formData = new FormData();
    const objString = JSON.stringify(sendMailObject);

    // formData.append("file", file);
    formData.append("request", objString);
    const config = {
      headers: {
        // "content-type": "multipart/form-data,application/json",
        timeZone: userTimeZone,
        language: userSelectedLanguage
      }
    };

    axios.post(url, formData, config).then((response) => {
      if (response.data) {
      }
    });
  });
};
